import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Badge, Heading, LinkButton, ModuleContainer } from "../../element";
import { Accordion } from "./Accordion";
export var AccordionContentBlock = function(param) {
    var content = param.content, rules = param.rules, translations = param.translations;
    var accordion = content.accordion, badge = content.badge, heading = content.heading;
    var ref = rules || {}, badgeRules = ref.badge, textStyle = ref.textStyle, verticalSpacing = ref.verticalSpacing;
    var style = (textStyle || {}).style;
    var ref1 = translations || {}, buttonLabel = ref1.buttonLabel, supportUrl = ref1.supportUrl;
    return /*#__PURE__*/ _jsxs(ModuleContainer, {
        rules: {
            verticalSpacing: verticalSpacing
        },
        children: [
            /*#__PURE__*/ _jsx(Badge, {
                content: badge,
                rules: {
                    badge: badgeRules
                }
            }),
            /*#__PURE__*/ _jsx(Heading, {
                content: heading,
                rules: {
                    textStyle: {
                        style: style
                    }
                }
            }),
            /*#__PURE__*/ _jsx(Accordion, {
                content: accordion
            }),
            supportUrl && buttonLabel && /*#__PURE__*/ _jsx(LinkButton, {
                content: {
                    href: supportUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    label: buttonLabel
                },
                rules: {
                    horizontalSpacing: {
                        isCentered: true
                    }
                },
                variant: "secondary"
            })
        ]
    });
};
